export const apiBaseUrl = import.meta.env.VITE_API_URL;
export const __DEV__ = import.meta.env.VITE_MODE === "development";
export const defaultLocaleCode = import.meta.env.VITE_DEFAULT_LOCALE_CODE;
export const appClientId = import.meta.env.VITE_CLIENT_ID;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const appPrefix = import.meta.env.VITE_APP_PREFIX;
export const googleMapApiKey = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const appName = import.meta.env.VITE_APP_NAME;
export const websiteDomain = import.meta.env.VITE_WEBSITE_DOMAIN;